import { UnidadeRecurso, Usuario } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';

export class UnidadeRecursoSubstituto extends BaseResourceModel {
  constructor(
    public id?: number,
    public usuario?: Usuario,
    public data_inicio?: Date,
    public data_termino?: Date,
    public cargo?: string,
    public unidade_recurso?: UnidadeRecurso,
    public editavel?: boolean,
  ) {
    super();
  }
  static converteJson(json: any): UnidadeRecursoSubstituto {
    return Object.assign(new UnidadeRecursoSubstituto(), json);
  }
}
